module.exports = Jsw.skinUrl + "/icons/16/plesk/uplevel.png?09738742d9a113e283a273f3445a1ba9";